import React from 'react';
import PropTypes from 'prop-types';

const ManageContentFieldGroup = ({ label, name, options, value, onChange, children, component }) => {
  const InputComponent = component;

  const checkIfSelected = (optionValue) => {
    const preSelectedOptions = value;
    let selectedBool = false;
    if (preSelectedOptions) {
      preSelectedOptions.map((option) => {
        if (option.id) {
          // If the option has an id key, use that (e.g. phase_of_the_game[{ id: 12345, name: "Defending" }])
          if (option.id === optionValue) {
            selectedBool = true;
          }
        } else if (option === optionValue) {
          // If the option has no id key, we assume it is simple array (e.g. ages[ 1,2,3,4,5 ])
          selectedBool = true;
        }
        return false;
      });
    }
    return selectedBool;
  };

  return (
    <div className="form-group form-inline">
      <span className="faux-label radio-group-heading">{label}</span>

      {children}

      <div className="form-inline__field-container">
        {options &&
          options.map(option => (
            <InputComponent
              key={option.value}
              name={name}
              label={option.label}
              onChange={onChange}
              value={option.value}
              checked={checkIfSelected(option.value)}
            />
          ))
        }
      </div>
    </div>
  );
};

ManageContentFieldGroup.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.array,
  onChange: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  component: PropTypes.func.isRequired,
};

export default ManageContentFieldGroup;



// WEBPACK FOOTER //
// ./library/app/components/Create/ManageContentFieldGroup.js